import { Injectable } from "@angular/core";
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { HandelssortimentsgruppDTO } from "../../../../../app/common/models/common/HandelssortimentsgruppDTO";

@Injectable({
    providedIn: "root"
})
export class DsoSearchService {

    searchParams: any;

    private readonly selectedLevel = {
        none: "none",
        partial: "partial",
        all: "all"
    };

    private readonly handelssortimentType = {
        group: "HG",
        handelssortiment: "HS"
    };

    setFilter(handelssortimentsgrupper: HandelssortimentsgruppDTO[], searchParams: any): SelectionItem[] {
        this.searchParams = searchParams;

        const res = [] as SelectionItem[];
        handelssortimentsgrupper.forEach(data => {
            res.push(this.createTreeSelectionNode(data));
        });
        this.setPartialSelected(res);

        return res;
    }

    getSelectedHandelssortiment(handelssortimentsgrupper: any) {
        const data = [];
        handelssortimentsgrupper.forEach((hsg: any) => {
            if (hsg.selected) {
                data.push( {
                    typ: this.handelssortimentType.group,
                    id: hsg.value
                });
            }

            if (hsg.selected || hsg.partialSelected) {
                hsg.children.forEach((hs: any) => {
                    if (hs.selected) {
                        data.push( {
                            typ: this.handelssortimentType.handelssortiment,
                            id: hs.value
                        });
                    }
                });
            }
        });

        return data;
    }

    private createTreeSelectionNode(node: any) {
        let children: SelectionItem[] = null;
        if (ObjectUtils.hasValue(node.children)) {
            children = children === null ? [] : children;
            node.children.forEach((data: any) => {
                children.push(this.createTreeSelectionNode(data));
            });

        }

        return {
            value: node.id,
            text: node.namn,
            selected: this.setNodeSelection(node),
            partialSelected: false,
            children: children
        } as SelectionItem;
    }

    private setNodeSelection(node: any): boolean {
        let res = false;
        if (this.searchParams === null || this.searchParams.handelssortiment === null) {
            return res;
        }

        if (ObjectUtils.hasValue(node.children)) {
            this.searchParams.handelssortiment.forEach((hs: any) => {
                if (hs.typ === this.handelssortimentType.group && hs.id === node.id) {
                    res = true;
                }
            });
        } else {
            this.searchParams.handelssortiment.forEach((hs: any) => {
                if (hs.typ === this.handelssortimentType.handelssortiment && hs.id === node.id) {
                    res = true;
                }
            });
        }

        return res;
    }

    private setPartialSelected(array: any): any {
        array.forEach((a: any) => {
            if (ObjectUtils.hasValue(a.children)) {
                const res = this.setSelectedChildren(a.children);
                if (res === this.selectedLevel.all) {
                    a.selected = true;
                } else if (res ===  this.selectedLevel.partial) {
                    a.partialSelected = true;
                }
            }
        });

        return array;
    }

    private setSelectedChildren(array: any): string {
        let numberOfSelected = 0;
        let isPartial = false;
        if (array === null) {
            return this.selectedLevel.none;
        }

        array.forEach((a: any) => {
            if (!a.selected && ObjectUtils.hasValue(a.children)) {
                const res = this.setSelectedChildren(a.children);
                if (res === this.selectedLevel.all) {
                    a.selected = true;
                } else if (res === this.selectedLevel.partial) {
                    a.partialSelected = true;
                    isPartial = true;
                }
            } else if (a.selected === true) {
                numberOfSelected++;
            }
        });
        if (numberOfSelected === 0 && !isPartial) {
            return this.selectedLevel.none;
        } else if (numberOfSelected === array.length) {
            return this.selectedLevel.all;
        } else if (isPartial || (numberOfSelected < array.length && numberOfSelected > 0)) {
            return this.selectedLevel.partial;
        }

        return this.selectedLevel.none;
    }
}
